(function () {
  const MIN_LOOP_SLIDES = 12;

  function isAutoscrollEnabled(wrapper) {
    return wrapper.getAttribute('data-autoscroll') !== 'false';
  }

  function ensureEnoughSlides(swiperEl, shouldClone) {
    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return 0;

    wrapper.querySelectorAll('.swiper-slide[data-pmg-clone]').forEach((clone) => clone.remove());

    const originals = Array.from(wrapper.querySelectorAll('.swiper-slide:not([data-pmg-clone])'));
    if (!originals.length) return 0;
    if (!shouldClone) return originals.length;

    let i = 0;
    while (wrapper.querySelectorAll('.swiper-slide').length < MIN_LOOP_SLIDES) {
      const clone = originals[i % originals.length].cloneNode(true);
      clone.setAttribute('data-pmg-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      wrapper.appendChild(clone);
      i += 1;
    }

    return wrapper.querySelectorAll('.swiper-slide').length;
  }

  function clearKeepAlive(wrapper) {
    if (wrapper._pmgKeepAlive) {
      clearInterval(wrapper._pmgKeepAlive);
      wrapper._pmgKeepAlive = null;
    }
  }

  function keepAutoplayAlive(wrapper, swiper) {
    clearKeepAlive(wrapper);
    if (!swiper?.autoplay) return;

    wrapper._pmgKeepAlive = setInterval(() => {
      const instance = swiperElRef(wrapper);
      if (!instance?.autoplay) return;
      if (!instance.autoplay.running) {
        instance.autoplay.start();
      }
    }, 1000);
  }

  function swiperElRef(wrapper) {
    const swiperEl = wrapper.querySelector('.product-media-full-width__swiper');
    return swiperEl?.productMediaSwiper || null;
  }

  function initProductMediaFullWidth(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-media-full-width]:not([data-pmg-initialized])').forEach((wrapper) => {
      const swiperEl = wrapper.querySelector('.product-media-full-width__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      wrapper.dataset.pmgInitialized = 'true';
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const marqueeSpeed = parseFloat(wrapper.dataset.marqueeSpeed || '8', 10);

      function getGap(isMobile) {
        const styles = getComputedStyle(wrapper);
        const gapVar = isMobile ? '--image-gap-mobile' : '--image-gap';
        const gap = parseInt(styles.getPropertyValue(gapVar), 10);
        return Number.isFinite(gap) ? gap : 0;
      }

      function buildOptions(isMobile, slideCount, autoscroll) {
        const options = {
          slidesPerView: 'auto',
          spaceBetween: getGap(isMobile),
          loop: autoscroll && slideCount > 1,
          watchOverflow: false,
          mousewheel: false,
          allowTouchMove: true,
        };

        if (autoscroll && slideCount > 1) {
          options.loopAdditionalSlides = slideCount;
          options.speed = marqueeSpeed * 1000;
          options.autoplay = {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            waitForTransition: true,
            stopOnLastSlide: false,
          };
          options.on = {
            autoplayStop(swiper) {
              if (swiper.autoplay) {
                requestAnimationFrame(() => swiper.autoplay.start());
              }
            },
            reachEnd(swiper) {
              if (swiper.autoplay) {
                swiper.autoplay.start();
              }
            },
          };
        } else {
          options.speed = 400;
          options.autoplay = false;
          if (slideCount > 1) {
            options.navigation = {
              nextEl: wrapper.querySelector('.product-media-full-width__button-next'),
              prevEl: wrapper.querySelector('.product-media-full-width__button-prev'),
            };
          }
        }

        options.breakpoints = {
          750: {
            spaceBetween: getGap(false),
          },
        };

        return options;
      }

      function createSwiper() {
        if (swiperEl.productMediaSwiper) {
          swiperEl.productMediaSwiper.destroy(true, true);
          swiperEl.productMediaSwiper = null;
        }

        clearKeepAlive(wrapper);

        const autoscroll = isAutoscrollEnabled(wrapper);
        const slideCount = ensureEnoughSlides(swiperEl, autoscroll);
        // Do not use withIslandSwiperDefaults — its mousewheel stops the marquee mid-scroll.
        swiperEl.productMediaSwiper = new Swiper(swiperEl, buildOptions(mobileQuery.matches, slideCount, autoscroll));
        if (autoscroll) keepAutoplayAlive(wrapper, swiperEl.productMediaSwiper);
      }

      createSwiper();

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', createSwiper);
      } else {
        mobileQuery.addListener(createSwiper);
      }
    });
  }

  window.initProductMediaFullWidth = initProductMediaFullWidth;

  document.addEventListener('DOMContentLoaded', () => initProductMediaFullWidth());
  document.addEventListener('shopify:section:load', (event) => initProductMediaFullWidth(event.target));
  document.addEventListener('shopify:block:load', (event) => initProductMediaFullWidth(event.target));
})();
